// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__BhD4i","default":"avatar_default__8uoBF"};